import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import colors from "PFTheme/tokens/colors";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { MarketplaceNavigationButton } from "../../../components";
import css from "./no_bookings_screen.module.scss";

export const NoBookingsScreen = () => {
  const { t } = useTranslation("marketplace", { keyPrefix: "dashboard.upcomingRoles.noBookings" });
  const history = useHistory();

  return (
    <div className={css.mainContainer}>
      <div className={css.top}>
        <Icon name="missing" fill={colors.paletteWhite0} />
        <Typography variant="bodyRegular">{t("noItems")}</Typography>
      </div>
      <MarketplaceNavigationButton
        onClick={() => history.push("/marketplace/work_opportunities/matching_roles")}
      >
        {t("browseOpportunities")}
      </MarketplaceNavigationButton>
    </div>
  );
};
